import { GATEWAY_CONFIG } from '../config/config';
import logger from './logger';

/**
 * Récupère l'état de l'abonnement actuel du client (crédits + activation).
 *
 * Retourne :
 *   - size_reco_active  {boolean} : crédits reco disponibles
 *   - vto_active        {boolean} : crédits VTO disponibles
 *   - reco_activation   {boolean} : reco activée par le marchand
 *   - vto_activation    {boolean} : VTO activé par le marchand
 *
 * Le backend renvoie 400 quand les deux crédits sont épuisés mais les champs
 * sont toujours présents dans le corps — on lit la réponse dans tous les cas.
 */
export const getCurrentSubscription = async (customerDomain) => {
  const url =
    GATEWAY_CONFIG.BASE_URL +
    GATEWAY_CONFIG.ENDPOINTS.CURRENT_SUBSCRIPTION.replace('{domain}', customerDomain);

  logger.log('🔍 Récupération de l\'abonnement:', url);

  const response = await fetch(url, {
    method: 'GET',
    headers: { 'Content-Type': 'application/json' },
  });

  const data = await response.json();

  if (!response.ok && response.status !== 400) {
    logger.error('❌ Erreur lors de la récupération de l\'abonnement:', data);
    throw new Error(data.details || 'Erreur lors de la récupération de l\'abonnement');
  }

  logger.log('✅ Abonnement reçu:', data);

  return {
    size_reco_active: !!data.size_reco_active,
    vto_active: !!data.vto_active,
    reco_activation: !!data.reco_activation,
    vto_activation: !!data.vto_activation,
  };
};
